export default defineNuxtPlugin(() => {
  function loadScript() {
    window.removeEventListener('touchstart', loadScript);
    window.removeEventListener('mousemove', loadScript);
    window.removeEventListener('scroll', loadScript);

    const script = document.createElement('script');
    const secondScript = document.createElement('script');

    script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.googleAnalyticsGa4Id}`;
    secondScript.innerHTML = `
          window.dataLayer = window.dataLayer || []
          function gtag(){ dataLayer.push(arguments) }
          gtag("js", new Date())
          gtag('config', '${process.env.googleAnalyticsGa4Id}')
          `;
    document.head.appendChild(script);
    document.head.appendChild(secondScript);
  }

  window.addEventListener('touchstart', loadScript);
  window.addEventListener('mousemove', loadScript);
  window.addEventListener('scroll', loadScript);
});
